var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 84,
    viewBox: "0 0 76 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 45.9998H58.8333V66.8332H38V45.9998ZM67.1667 8.49984H63V0.166504H54.6667V8.49984H21.3333V0.166504H13V8.49984H8.83333C4.25 8.49984 0.5 12.2498 0.5 16.8332V75.1665C0.5 79.7498 4.25 83.4998 8.83333 83.4998H67.1667C71.75 83.4998 75.5 79.7498 75.5 75.1665V16.8332C75.5 12.2498 71.75 8.49984 67.1667 8.49984ZM67.1667 16.8332V25.1665H8.83333V16.8332H67.1667ZM8.83333 75.1665V33.4998H67.1667V75.1665H8.83333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.68c23e9f6da8580967605794ac66ab97.svg";
export { ForwardRef as ReactComponent };